export const SOLUTION_KEYS = {
  LEAD_MANAGEMENT: 'leadManagement',
  LEAD_GENERATION: 'leadGeneration',
}
